/**
 * Configura come e cosa prendere da Trello
 */
export const TrelloConfig = Object.freeze({
    // Chiave dell'app che hai registato su Trello
    appKey: 'dba77d57bb8c8cce773e571b746e414f',
    // Bacheca dalla quale pescare la lista dei membri
    // e la lista delle etichette filtrabili
    mainBoardId: '5b87e7c4ed117a3434dd0cf1', // ___TASK CLIENTI'
    // Bacheche dove vivono le card da mostrare
    // I nomi delle bachece sono matchati come substrings
    boardsToShow: [
        '___TASK CLIENTI',
        'Project',
        'INofficina - Attivazione',
        '_RICERCA',
    ],
})

/**
 * Configura cosa mostrare nella dashboard
 */
export const uiConfig = Object.freeze({
    // Mostra i nome delle etichette di ogni singola card?
    showInlineLabels: true,
    // Mostra i nomi delle etichette nel filtro etichetta?
    showLabelNamesInFilter: false,
    // Mostra la sezione sulle statistiche
    showOpenCardsStats: false,
})
